import { createAction, props } from '@ngrx/store';
import * as Types from '../modals';

export const FollowUpUpdate = createAction('[FollowUp] Update', props<Partial<Types.FollowUpStateI>>());
